<template>
  <div>
    <div v-if="currentState <= STATE_FREE">
      <div style="
          position: fixed;
          z-index: 2;
          top: 60px;
          width: 100%;
          padding-bottom: 20px;
          background-color: #efefef;
        " v-if="hasSchool">
        <app-history @clicked="goToFreeDiscussion()" title="مباحثات آزاد" />
      </div>
      <div v-if="discussions.length > 0">
        <div class="fixedPosition" :style="[
          isMobile ? { width: '100%' } : { width: 'calc(100% - 300px)' },
          hasSchool ? { top: '140px' } : { top: '60px' },
        ]" v-if="hasSchool">
          <div class="divider dparent">
            <b> {{ discussions[visibleDiscussion].Ncycle }}</b>
          </div>
        </div>
        <div style="position: relative; padding-bottom: 50px" :style="[hasSchool ? { top: '160px' } : { top: '0px' }]">
          <div v-for="(discussion, index) in discussions" :key="discussion.Srl_cycle">
            <div v-if="index != visibleDiscussion" class="divider dparent">
              <b> {{ discussion.Ncycle }}</b>
            </div>

            <v-data-table :items="discussion.discussions" :headers="discussionHeaders"
              class="elevation-1 withBtn discussions" :disable-pagination="true" :hide-default-footer="true"
              :no-data-text="tableText" :header-props="headerProps" :mobile-breakpoint="780"><template
                v-slot:[`item.PerAdmin`]="{ item }">
                <v-btn class="grid" v-if="item.isAdmin" color="red white--text" rounded @click="getMembers(item)">
                  {{
                    item.Active && item.PerAdmin ? "مدیریت اعضا" : "مشاهده اعضا"
                  }}
                </v-btn>
              </template>
              <template v-slot:[`item.isAdmin`]="{ item }">
                <v-btn class="grid" color="red white--text" rounded @click="getSessions(item)">
                  {{
                    item.Active && item.isAdmin
                      ? "مدیریت جلسات"
                      : "مشاهده جلسات"
                  }}
                </v-btn>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
      <div v-else>
        <v-main style="margin: 30px; position: relative" :style="[hasSchool ? { top: '70px' } : '']">
          {{ tableText }}</v-main>
      </div>
    </div>
    <div v-else-if="currentState == STATE_USER">
      <!-- <br />
      <v-btn
        color="primary white--text"
        class="historyButton"
        rounded
        v-if="selectedDiscussion.PerAdmin"
        @click="showUsers"
      >
        افزودن فرد
      </v-btn>
      <br />
      <br /> -->
      <div class="fullText" style="margin: 20px">
        {{
          `ليست اعضای گروه مباحثه ${selectedDiscussion.Fname}
        ${hasSchool
            ? " درس " +
            selectedDiscussion.N_Title +
            " استاد " +
            selectedDiscussion.TeacherFName
            : ""
          } با سرپرستی
        ${selectedDiscussion.N_Admin}`
        }}
      </div>
      <v-data-table :items="members" :headers="memberHeaders" class="elevation-1 withBtn" :disable-pagination="true"
        :hide-default-footer="true" :no-data-text="tableText" :header-props="headerProps"
        :mobile-breakpoint="450"><template v-slot:[`item.Fserial`]="{ item }">
          <v-btn class="grid" v-if="selectedDiscussion.PerAdmin" color="red white--text" rounded
            @click="removeMember(item.Fserial)">
            حذف
          </v-btn>
        </template>
      </v-data-table>
      <div>
        <v-btn class="addBtn" color="primary white--text" fab v-if="selectedDiscussion.PerAdmin" @click="showUsers">
          <v-icon large>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="showDialog" max-width="600" persistent>
        <v-card style="padding-top: 1px">
          <v-card-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="جستجو" single-line reverse
              hide-details></v-text-field>
          </v-card-title>
          <v-data-table :items="users" :headers="memberHeaders" class="elevation-1 withBtn" :no-data-text="tableText"
            no-results-text="نتیجه ای یافت نشد" :header-props="headerProps" :mobile-breakpoint="450"
            :search="toArabicCharacter(search)" :footer-props="{
              itemsPerPageAllText: 'همه',
              itemsPerPageText: 'تعداد ردیف',
            }">
            <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
              از {{ pageStart }} تا {{ pageStop }}
            </template>
            <template v-slot:[`item.Fserial`]="{ item }">
              <v-btn class="grid" color="red white--text" rounded @click="addMember(item.Fserial)">
                افزودن
              </v-btn>
            </template>
          </v-data-table>
          <v-card-actions style="direction: ltr">
            <v-btn class="register" color="primary white--text" rounded @click="closeAddDialog">
              بستن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div v-else-if="currentState == STATE_SESSION_USER">
      <div class="fullText" style="margin: 20px">
        {{
          `ليست جلسات گروه مباحثه ${selectedDiscussion.Fname}
        ${hasSchool
            ? " درس " +
            selectedDiscussion.N_Title +
            " استاد " +
            selectedDiscussion.TeacherFName
            : ""
          } با سرپرستی
        ${selectedDiscussion.N_Admin}`
        }}
      </div>

      <v-data-table :items="sessions" :headers="sessionHeaders" class="elevation-1" :disable-pagination="true"
        :hide-default-footer="true" :no-data-text="tableText" :header-props="headerProps" :mobile-breakpoint="450">
      </v-data-table>
    </div>
    <div v-else-if="currentState == STATE_SESSION_ADMIN">
      <!-- <br />
      <v-btn
        color="primary white--text"
        class="historyButton"
        rounded
        @click="showSession(emptySession)"
      >
        افزودن جلسه مباحثه
      </v-btn>
      <br />
      <br /> -->
      <div class="fullText" style="margin: 20px">
        ليست جلسات مباحثه گروه مباحثه درس {{ selectedDiscussion.N_Title }} استاد
        {{ selectedDiscussion.TeacherFName }} با سرپرستی
        {{ selectedDiscussion.N_Admin }}
        <br />
        <br />
        <b>نکات</b>
        <br />
        <div style="margin: 20px">
          شما در اين بخش قادر خواهيد بود، جلسات مباحثه را در سیستم وارد نموده و
          برای هر کدام از اعضای گروه نمره ثبت کنید.
          <br />
          سیستم فقط اجازه ثبت جلسه مباحثه، در ماه جاری را می دهد. هم چنین امکان
          ثبت جلسه مباحثه ای که هنوز تشکیل نشده است نیز در سیستم وجود ندارد.
          <br />

          لازم است برای کلیه اعضای گروه مباحثه، نمره ثبت شود. در صورت عدم ثبت
          نمره برای یک نفر، سیستم برای ایشان نمره صفر منظور کرده و وضعیت ایشان
          در جلسه را غیبت ثبت می کند.
          <br />
          به طور کلی هر نفر در یک جلسه مباحثه یک نمره ارزشیابی دارد.
        </div>
      </div>
      <v-data-table :items="sessions" :headers="sessionHeaders" class="elevation-1 withBtn sessions"
        :disable-pagination="true" :hide-default-footer="true" :no-data-text="tableText" :header-props="headerProps"
        :mobile-breakpoint="700">
        <template v-slot:[`item.Hozoor_Admin`]="{ item }">
          <span>
            {{ getHozoorString(item.Hozoor_Admin) }}
          </span>
        </template>
        <template v-slot:[`item.Barrasi_Erjaat`]="{ item }">
          <span>
            {{ getBarrasiString(item.Barrasi_Erjaat) }}
          </span>
        </template>
        <template v-slot:[`item.allMarks`]="{ item }">
          <v-btn class="grid" color="red white--text" rounded @click="showSession(item)" width="150">
            {{ item.editable ? "مشاهده و ویرایش" : "مشاهده" }}
          </v-btn>
        </template>
        <template v-slot:[`item.Fserial`]="{ item }">
          <v-btn v-if="item.editable" class="grid" color="red white--text" rounded @click="removeSession(item.Fserial)">
            حذف
          </v-btn>
        </template>
      </v-data-table>
      <div>
        <v-btn class="addBtn" color="primary white--text" fab v-if="selectedDiscussion.isAdmin"
          @click="showSession(JSON.parse(JSON.stringify(emptySession)))">
          <v-icon large>mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
    <div v-else-if="currentState == STATE_SESSION_CREATE">
      <div class="fullText" style="margin: 20px">
        ليست جلسات مباحثه گروه مباحثه درس {{ selectedDiscussion.N_Title }} استاد
        {{ selectedDiscussion.TeacherFName }} با سرپرستی
        {{ selectedDiscussion.N_Admin }}
      </div>
      <div class="form">
        <v-row align="center">
          <v-col class="d-flex" cols="4" sm="3">
            <b>تاریخ *</b>
          </v-col>
          <v-col class="d-flex" cols="8" sm="3">
            <v-btn class="form-center" color="orange white--text" rounded @click="onClickDate"
              v-if="selectedSession.editable">
              {{
                startSelected || selectedSession.D_Discussion != ""
                  ? selectedSession.D_Discussion
                  : "انتخاب تاریخ"
              }}
            </v-btn>
            <v-main v-else style="text-align: left">
              {{ selectedSession.D_Discussion }}
            </v-main>
          </v-col>
          <v-col class="d-flex" cols="4" sm="3">
            <b>مکان *</b>
          </v-col>
          <v-col class="d-flex" cols="8" sm="3">
            <v-text-field v-model="selectedSession.L_Discussion" v-if="selectedSession.editable"></v-text-field>
            <v-main v-else style="text-align: left">
              {{ selectedSession.L_Discussion }}
            </v-main>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col class="d-flex" cols="4" sm="3">
            <b>ساعت شروع *</b>
          </v-col>
          <v-col class="d-flex" cols="8" sm="3">
            <v-text-field v-model="selectedSession.T_Start" maxlength="5" :oninput="onInput"
              v-if="selectedSession.editable"></v-text-field>
            <v-main style="text-align: left" v-else>
              {{ selectedSession.T_Start }}
            </v-main>
          </v-col>
          <v-col class="d-flex" cols="4" sm="3">
            <b>ساعت پایان *</b>
          </v-col>
          <v-col class="d-flex" cols="8" sm="3">
            <v-text-field v-model="selectedSession.T_End" maxlength="5" :oninput="onInput"
              v-if="selectedSession.editable">
            </v-text-field>
            <v-main style="text-align: left" v-else>
              {{ selectedSession.T_End }}
            </v-main>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col class="d-flex" cols="10" sm="4">
            <b>غیبت سرپرست گروه مباحثه</b>
          </v-col>
          <v-col class="d-flex" cols="2" sm="2" style="direction: ltr">
            <v-switch color="primary" v-model="isAbsent" v-if="selectedSession.editable"
              @change="updateHozoor"></v-switch>
            <v-main v-else>
              {{ getHozoorString(selectedSession.Hozoor_Admin) }}
            </v-main>
          </v-col>
          <v-col class="d-flex" cols="10" sm="4">
            <b>بررسی ارجاعات طلاب</b>
          </v-col>
          <v-col class="d-flex" cols="2" sm="2" style="direction: ltr">
            <v-switch color="primary" v-model="isBarrasi" v-if="selectedSession.editable"
              @change="updateBarrasi"></v-switch>
            <v-main v-else>
              {{ getBarrasiString(selectedSession.Hozoor_Admin) }}
            </v-main>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="3">
            <b>توضیحات</b>
          </v-col>
          <v-col class="d-flex" cols="12" sm="9">
            <v-textarea outlined v-model="selectedSession.Comment_Dis" v-if="selectedSession.editable"
              no-resize></v-textarea>
            <v-main v-else> {{ selectedSession.Comment_Dis }} </v-main>
          </v-col>
        </v-row>
      </div>
      <date-picker ref="datepicker1" v-model="selectedSession.D_Discussion" :editable="false" :auto-submit="true"
        element="fileInput1" @change="onChangeDate($event)" :max="TODAY" :min="startMonth"></date-picker>
      <input hidden id="fileInput1" ref="fileInput1" />
      <v-data-table :items="members" :headers="memberHeaders" class="elevation-1 marks" :disable-pagination="true"
        :hide-default-footer="true" :no-data-text="tableText" :header-props="headerProps" :mobile-breakpoint="450">
        <template v-slot:[`item.Mark`]="{ item }">
          <v-text-field v-if="selectedSession.editable" v-model.number="item.Mark" outlined hide-details type="number"
            class="markText">
          </v-text-field>
          <v-main v-else> {{ item.Mark }} </v-main>
        </template>
      </v-data-table>
      <v-card-actions style="direction: ltr" v-if="selectedSession.editable">
        <v-btn class="register" color="red white--text" @click="saveSession" rounded>
          ثبت
        </v-btn>
      </v-card-actions>
    </div>
    <app-dialog @close="onCloseRemove"></app-dialog>
  </div>
</template>

<script>
import {
  getHistory,
  getMembers,
  searchPeople,
  saveMember,
  removeMember,
  getStudentSessions,
  getAdminSessions,
  removeSession,
  saveSession,
} from "@/api/discussion";
import Dialog from "@/components/Dialog";
import { TODAY } from "@/utils/constants";
import moment from "moment-jalaali";
import HistoryButton from "@/components/HistoryButton";
import { toArabicDigit } from "@/utils/constants";
import { toArabicCharacter } from "../../utils/constants";

export default {
  components: {
    appDialog: Dialog,
    appHistory: HistoryButton,
  },
  data() {
    return {
      discussions: [],
      members: [],
      users: [],
      sessions: [],
      visibleDiscussion: null,
      selectedDiscussion: -1,
      selectedSession: null,
      search: "",
      hasSchool: true,
      headerProps: {
        sortByText: "مرتب سازی بر اساس",
      },
      STATE_INDEX: 0,
      STATE_FREE: 1,
      STATE_USER: 2,
      STATE_SESSION_ADMIN: 3,
      STATE_SESSION_USER: 4,
      STATE_SESSION_CREATE: 5,
      states: [],
      showDialog: false,
      removeType: "",
      emptySession: {
        Comment_Dis: "",
        D_Discussion: "",
        Fserial: 0,
        L_Discussion: "",
        T_End: "",
        T_Start: "",
        allMarks: [],
        editable: true,
        Srl_DiscussionGrp: 0,
        Hozoor_Admin: "0",
        Barrasi_Erjaat: "0",
      },
      isAbsent: false,
      isBarrasi: false,
      TODAY: TODAY,
    };
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    currentState() {
      return this.states[this.states.length - 1];
    },

    discussionHeaders() {
      let headers = [];
      if (this.hasSchool) {
        headers = [
          ...headers,
          {
            text: "نام درس",
            value: "N_Title",
            width: "15%",
          },
          {
            text: "کد درس",
            value: "Srl_Title",
            width: "7%",
          },
          {
            text: "نام استاد",
            value: "TeacherFName",
            width: "15%",
          },
        ];
      }
      headers = [
        ...headers,
        {
          text: "نام گروه",
          value: "Fname",
          width: "15%",
        },
        {
          text: "نام سرپرست گروه",
          value: "N_Admin",
          width: "15%",
        },

        {
          text: "شناسه سرپرست گروه",
          value: "Num_System",
          width: "8%",
        },
        {
          text: "",
          value: "PerAdmin",
          width: "10%",
          sortable: false,
        },
        {
          text: "",
          value: "isAdmin",
          width: "10%",
          sortable: false,
        },
      ];
      return headers;
    },
    memberHeaders() {
      let headers = [
        {
          text: "شناسه فرد",
          value: "Num_System",
          width: "25%",
        },
        {
          text: "نام فرد",
          value: "Fname",
          width: "25%",
        },
      ];
      if (this.currentState == this.STATE_USER) {
        headers.push({
          text: "",
          value: "Fserial",
          width: "10%",
          sortable: false,
          filterable: false,
        });
      } else {
        headers.push({
          text: "نمره",
          value: "Mark",
          width: "10%",
          sortable: false,
          filterable: false,
        });
      }
      return headers;
    },
    sessionHeaders() {
      let headers = [
        {
          text: "تاریخ مباحثه",
          value: "D_Discussion",
          width: "15%",
        },
        {
          text: "مکان مباحثه",
          value: "L_Discussion",
          width: "25%",
        },
        {
          text: "ساعت شروع",
          value: "T_Start",
          width: "10%",
        },
        {
          text: "ساعت پایان",
          value: "T_End",
          width: "10%",
        },
      ];
      if (this.selectedDiscussion.isAdmin) {
        headers.push(
          {
            text: "حضور سرپرست مباحثه",
            value: "Hozoor_Admin",
            width: "20%",
          },
          {
            text: "بررسی ارجاعات طلاب",
            value: "Barrasi_Erjaat",
            width: "20%",
          },
          {
            text: "",
            value: "allMarks",
            width: "10%",
          },
          {
            text: "",
            value: "Fserial",
            width: "10%",
          }
        );
      } else {
        headers.push({
          text: "نمره",
          value: "Mark",
          width: "10%",
        });
      }
      return headers;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
    startMonth() {
      return moment().startOf("jMonth").format("jYYYY/jM/jD");
    },
  },

  watch: {
    // Watch for route changes to handle browser back/forward buttons
    '$route.query': {
      handler(newQuery) {
        this.handleRouteChange(newQuery);
      },
      immediate: true
    }
  },

  created() {
    this.initializeFromQueryParams();
    this.getHistory();

    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    toArabicCharacter(string) {
      return toArabicCharacter(string);
    },
    goToFreeDiscussion() {
      const newStates = [...this.states, this.STATE_FREE];
      this.updateUrlWithState(newStates);
      this.hasSchool = false;
      this.setHeaderTitle();
      this.getHistory();
    },
    // Query parameter methods
    getCurrentStateFromQuery() {
      const stateParam = this.$route.query.state;
      if (!stateParam) return [this.STATE_INDEX];

      return stateParam.split(',').map(Number).filter(num => !isNaN(num));
    },

    updateUrlWithState(stateArray) {
      if (stateArray.length === 1 && stateArray[0] === this.STATE_INDEX) {
        // If we're at root state, remove query params
        this.$router.push({ query: {} });
      } else {
        // Convert state array to comma-separated string
        this.$router.push({
          query: {
            state: stateArray.join(','),
            // Preserve other data if needed
            discussion: this.selectedDiscussion.Fserial || '',
            session: this.selectedSession?.Fserial || ''
          }
        });
      }
    },

    initializeFromQueryParams() {
      const stateArray = this.getCurrentStateFromQuery();
      if (stateArray.length > 0) {
        this.states = stateArray;
        this.setHeaderTitle();

        // Load data based on current state
        if (this.currentState === this.STATE_INDEX) {
          this.getHistory();
        }
        // You can add more state-specific initialization here
      } else {
        this.states = [this.STATE_INDEX];
      }
    },

    handleRouteChange(queryParams) {

      const stateArray = this.getCurrentStateFromQuery();
      const previousState = this.currentState;
      this.states = stateArray;
      this.setHeaderTitle();

      // Handle state transitions and data loading
      this.handleStateTransition(previousState, this.currentState);
    },

    handleStateTransition(previousState, currentState) {
      window.scrollTo(0, 0);
      // If going back to index state, reload history
      if (currentState === this.STATE_INDEX && previousState !== this.STATE_INDEX) {
        this.getHistory();
      }

      // If we're going back from free state to index, reset hasSchool
      if (currentState === this.STATE_INDEX && previousState === this.STATE_FREE) {
        this.hasSchool = true;
        this.getHistory();
      }
    },

    // Modified navigation methods to use query params
    getMembers(item = null) {
      if (item != null) {
        this.selectedDiscussion = item;
        const newStates = [...this.states, this.STATE_USER];
        this.updateUrlWithState(newStates);
        this.setHeaderTitle();
      }
      this.members = [];

      this.$store.commit("SET_TABLE_TEXT", true);
      getMembers(this.selectedDiscussion.Fserial)
        .then((response) => {
          const data = response.data;
          this.members = data;
          if (this.selectedSession != null)
            this.selectedSession.allMarks = data;
          this.$store.commit("SET_TABLE_TEXT", false);
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },

    getSessions(item = null) {
      if (item != null) {
        this.selectedDiscussion = item;
        const newState = item.isAdmin ? this.STATE_SESSION_ADMIN : this.STATE_SESSION_USER;
        const newStates = [...this.states, newState];
        this.updateUrlWithState(newStates);
        this.setHeaderTitle();
      }
      this.sessions = [];

      this.$store.commit("SET_TABLE_TEXT", true);
      if (this.selectedDiscussion.isAdmin) {
        getAdminSessions(this.selectedDiscussion.Fserial)
          .then((response) => {
            const data = response.data;
            this.sessions = data;
            this.$store.commit("SET_TABLE_TEXT", false);
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      } else {
        getStudentSessions(this.selectedDiscussion.Fserial)
          .then((response) => {
            const data = response.data;
            this.sessions = data;
            this.$store.commit("SET_TABLE_TEXT", false);
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },

    showSession(item) {
      this.startSelected = false;
      if (item != null) {
        this.selectedSession = item;
        this.isAbsent = this.selectedSession.Hozoor_Admin == "1";
        this.isBarrasi = this.selectedSession.Barrasi_Erjaat == "1";
        const newStates = [...this.states, this.STATE_SESSION_CREATE];
        this.updateUrlWithState(newStates);
        this.setHeaderTitle();
      }
      if (this.selectedSession.Fserial == 0) {
        this.selectedSession.Srl_DiscussionGrp =
          this.selectedDiscussion.Fserial;
        if (this.sessions.length > 0) {
          const lastSession = this.sessions[this.sessions.length - 1];
          this.selectedSession.L_Discussion = lastSession.L_Discussion;
          this.selectedSession.T_Start = lastSession.T_Start;
          this.selectedSession.T_End = lastSession.T_End;
        }
        this.search = "";
        this.getMembers();
      } else {
        this.members = this.selectedSession.allMarks;
      }
    },

    // Add back navigation method
    goBack() {
      if (this.states.length > 1) {
        const newStates = this.states.slice(0, -1);
        this.updateUrlWithState(newStates);
      }
    },

    getHistory() {
      this.discussions = [];
      this.$store.commit("SET_TABLE_TEXT", true);
      getHistory(this.hasSchool)
        .then((response) => {
          const data = response.data;
          this.discussions = data;
          if (this.discussions.length > 0) {
            this.visibleDiscussion = 0;
          }
          this.$store.commit("SET_TABLE_TEXT", false);
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },

    showUsers() {
      this.showDialog = true;
      this.users = [];
      this.$store.commit("SET_TABLE_TEXT", true);
      searchPeople(this.selectedDiscussion.Fserial, this.hasSchool)
        .then((response) => {
          const data = response.data;
          this.users = data;
          this.$store.commit("SET_TABLE_TEXT", false);
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },

    addMember(Fserial) {
      saveMember(this.selectedDiscussion.Fserial, Fserial)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          if (data.Success) {
            this.search = "";
            this.showUsers();
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },

    closeAddDialog() {
      this.showDialog = false;
      this.search = "";
      this.getMembers();
    },

    removeMember(index) {
      this.removeType = "removemember";
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این طلبه هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },

    removeSession(index) {
      this.removeType = "removesession";
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این جلسه هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },

    onCloseRemove(index) {
      if (index != -1) {
        if (this.removeType == "removemember") {
          removeMember(index)
            .then((response) => {
              const data = response.data;
              this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

              if (data.Success) {
                this.search = "";
                this.getMembers();
              }
            })
            .catch((error) => {
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
              );
            });
        } else if (this.removeType == "removesession") {
          removeSession(index)
            .then((response) => {
              const data = response.data;
              this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

              if (data.Success) {
                this.getSessions();
              }
            })
            .catch((error) => {
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
              );
            });
        } else if (this.removeType == "addsession") {
          saveSession(this.selectedSession)
            .then((response) => {
              const data = response.data;
              this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

              if (data.Success) {
                this.goBack(); // Use goBack instead of states.pop()
                this.getSessions();
              }
            })
            .catch((error) => {
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
              );
            });
        }
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },

    saveSession() {
      if (
        this.selectedSession.D_Discussion.trim() == "" ||
        this.selectedSession.L_Discussion.trim() == "" ||
        this.selectedSession.T_Start.trim() == "" ||
        this.selectedSession.T_End.trim() == ""
      ) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "لطفا مقادیر اجباری را پر فرمایید."
        );
        return;
      }
      for (let mark of this.selectedSession.allMarks) {
        const m = Number(mark.Mark);
        if ((!m && m != 0) || m > 20 || m < 0) {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "حداقل یکی از نمرات ورودی معتبر نیست."
          );
          return;
        }
      }
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.removeType = "addsession";
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", this.selectedSession.Fserial);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا از صحت اطلاعات ورودی اطمینان دارید"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },

    handleScroll() {
      var elements = document.querySelectorAll(".scrollHandler");
      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];

        var position = element.getBoundingClientRect();

        // checking whether fully visible
        if (position.bottom >= 160) {
          var elId = element.id.split("_");
          this.visibleDiscussion = parseInt(elId[0]);
          this.visibleCourse = elId[1];

          break;
        }
      }
    },

    onClickDate() {
      this.$refs.fileInput1.click();
    },

    onChangeDate($event) {
      let date = moment($event).format("jYYYY/jMM/jDD");

      this.selectedSession.D_Discussion = date;
      this.startSelected = true;
    },

    setHeaderTitle() {
      let headerTitle = "";
      switch (this.currentState) {
        case this.STATE_INDEX:
          headerTitle = "مباحثات";
          break;
        case this.STATE_FREE:
          headerTitle = "مباحثات آزاد";
          break;
        case this.STATE_USER:
          headerTitle = "اعضای مباحثه";
          break;
        case this.STATE_SESSION_ADMIN:
        case this.STATE_SESSION_USER:
          headerTitle = "جلسات مباحثه";
          break;
        case this.STATE_SESSION_CREATE:
          headerTitle = !this.selectedSession.editable
            ? "جزییات جلسه"
            : this.selectedSession.Fserial == 0
              ? "ثبت جلسه"
              : "ویرایش جلسه";
      }
      this.$store.commit("SET_HEADER_TITLE", headerTitle);
    },

    getHozoorString(value) {
      return value == "1" ? "غیبت" : "حضور";
    },

    getBarrasiString(value) {
      return value == "1" ? "بررسی" : "عدم بررسی";
    },

    updateHozoor(value) {
      this.selectedSession.Hozoor_Admin = value ? "1" : "0";
      this.isAbsent = value;
    },

    updateBarrasi(value) {
      this.selectedSession.Barrasi_Erjaat = value ? "1" : "0";
      this.isBarrasi = this.selectedSession.Barrasi_Erjaat == "1";
    },
  },

  // Remove beforeRouteLeave completely
};
</script>
<style scoped>
.fixedPosition {
  height: 80px;
}

.v-card {
  margin: 0;
  padding: 30px 10px 10px;
  border-radius: 4px !important;
}

.register {
  width: 30% !important;
  max-width: 150px !important;
}
</style>
<style>
.withBtn td {
  height: 56px !important;
}

.discussions tbody tr .v-data-table__mobile-row:nth-child(7),
.sessions tbody tr .v-data-table__mobile-row:nth-child(7) {
  float: right;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.marks tbody tr td .v-data-table__mobile-row__cell {
  display: inline-table;
}

.sessions {
  margin-bottom: 110px !important;
}

.markText {
  display: inherit;
  padding: 10px 0 5px !important;
}

.markText input {
  width: 50px;
  text-align: center;
}
</style>
